'use strict';

var React = require('react');

var SvgImportMinor = function SvgImportMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.707 10.707a.999.999 0 1 0-1.414-1.414l-1.293 1.293v-7.586a1 1 0 1 0-2 0v7.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l3 3a.999.999 0 0 0 1.414 0l3-3zm-10.707 5.293a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-14z"
  }));
};

exports.SvgImportMinor = SvgImportMinor;
